import { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

/**
 * Pulls the FastAPI `detail` message out of an RTK Query mutation's rejected
 * value (as thrown by `.unwrap()`), falling back to a generic message for
 * anything else -- a network error, a validation error shaped differently,
 * or a non-API exception.
 */
export function getApiErrorDetail(e: unknown, fallback: string): string {
  if (e && typeof e === "object" && "data" in e) {
    const data = (e as FetchBaseQueryError).data;
    if (data && typeof data === "object" && "detail" in data) {
      const detail = (data as { detail?: unknown }).detail;
      if (typeof detail === "string") return detail;
    }
  }
  return fallback;
}
